export const s3Url = "https://d49qdhygt0dif.cloudfront.net";
export const url = process.env.REACT_APP_BASE_URL;
export const siteId = process.env.REACT_APP_SITE_ID;
// export const email = process.env.REACT_APP_EMAIL;
// export const password = process.env.REACT_APP_PASSWORD;
export const email = process.env.REACT_APP_EMAIL;
export const password = process.env.REACT_APP_PASSWORD;
export const esplanadeUser = process.env.ESPLANADE_USER;
export const esplanadePass = process.env.ESPLANADE_PASS;

export const adsignMapConfiguration = {
  siteId: "67808c65ae6b636fdae317fc",
  adsignId: "64ed9aea7b776ae8d9d88b6f",
  channelId: "0194de38-eb4c-766d-a101-ad94e3e6ad8b",
  platformType: "web",
  api: "https://api.adsign.adactive.asia",
  username: "screen@suntec.com",
  password: "Password12345@",
  assetUrl: "https://d49qdhygt0dif.cloudfront.net",
};

export const mapOption = {
  hideUserLocation: true,
  highlightColor: "#4999A3",
  isShowAllFloor: false,
  floorLabel: {
    color: "white",
    size: 5,
  },
  isDisplayMinimap: false,
};
